import { SkeletonText } from '@buffer-mono/popcorn'

import { WeeklyPulseSkeleton } from './InsightsSummaryModule/WeeklyPulse'

import styles from './InsightsSummaryModule/WeeklyPulse.module.css'

import type { JSX } from 'react'

/**
 * Placeholder for the slot between the scorecard and the main content while
 * the checklist query decides which module (FirstSteps or Insights) owns it.
 * It mirrors the Insights module's geometry — the slot's most common resolved
 * state — so the sections below hold their position while the query runs.
 */
export function HomeSlotSkeleton(): JSX.Element {
  return (
    <section aria-busy>
      <div className={styles.header}>
        <SkeletonText lines={1} width={160} />
      </div>
      <WeeklyPulseSkeleton />
    </section>
  )
}
